import { connect } from "react-redux"

import { FeedRejectionReasonModal } from "../../common/FeedRejectionReasonModal"
import {
    feedModerate,
    feedToggleRejectionReasonModal
} from "../../../actions/feed-actions"

const mapDispatchToProps = dispatch => ({
    toggle: () => dispatch(feedToggleRejectionReasonModal()),
    reject: reason => {
        dispatch(feedToggleRejectionReasonModal())
        dispatch(feedModerate(false, reason))
    }
})

export default connect(null, mapDispatchToProps)(FeedRejectionReasonModal)
